/**
 * Presets for data lists
 */

     export default (tools) => {

         const onChangeView = (key, row = {}, data = {}, pane = {}) => {
            const obj = {
                key,
                title: row.breadcrumb,
                owner: row.owner,
                data: {
                    ...row,
                    ...data,
                    pane,
                }
            };
            tools.changeView(obj);
         }

         const onChangeViewFull = (row, options = {}, data = {}) => {
             tools.changeView({
                 key: 'pane-full-view',
                 title: row.breadcrumb,
                 owner: row.owner,
                 ...options,
                 data: {
                     hide: {
                         search: true,
                         results: true,
                     },
                     pane: row,
                     ...data,
                 }
             });
         }

         const replaceCurrentPreviewPaneData = (data) => {
             tools.updateCurrentViewData({
                 pane: data,
             });
             if (tools.currentApp.panes.preview === false) {
                tools.actions.togglePane('preview', true);
             }
         }

         return {
             // Order table options
             order: {
                 pane: {
                     header: ['No.', '', 'Item ordered'],
                     row: (row) => {
                         return {
                            onClick: () => onChangeViewFull(row),
                            items: [
                                row.title,
                                {
                                    text: row.items + "×",
                                    classes: 'align-right',
                                },
                                row.name,
                            ],
                         };
                     },
                 },
                 full: {
                     header: ['No.', '', 'Item ordered'],
                     row: (row) => {
                         return {
                            onClick: () => onChangeViewFull(row),
                            items: [
                                row.title,
                                {
                                    text: row.items + "×",
                                    classes: 'align-right',
                                },
                                row.name,
                            ],
                         };
                     },
                 },
                 results: {
                     header: ['No.', '', 'Item ordered'],
                     row: (row) => {
                         return {
                            onClick: () => replaceCurrentPreviewPaneData(row),
                            items: [
                                row.title,
                                {
                                    text: row.items + "×",
                                    classes: 'align-right',
                                },
                                row.name,
                            ],
                         };
                     },
                 },
             },

             // Item table options
             item: {
                 pane: {
                     header: [],
                     row: (row) => {
                         return {
                             onClick: () => onChangeViewFull(row),
                             items: [row.title]
                         };
                     },
                 },
                 full: {
                     header: ['Name', 'Material Type', 'items', 'ok'],
                     row: (row) => {
                         return {
                             onClick: () => onChangeViewFull(row),
                             items: [row.name, row.material_type, row.sent, row.items]
                         };
                     },
                 },
                 results: {
                     header: ['Barcode', 'Instance', 'Location'],
                     row: (row) => {
                         return {
                             onClick: () => replaceCurrentPreviewPaneData(row),
                             items: [row.barcode, row.title, 'Main library › K.243.2']
                         };
                     },
                 },
             },

             // Instance table options
             instance: {
                 pane: {
                     header: [],
                     row: (row) => {
                         return {
                             onClick: () => onChangeViewFull(row),
                             items: [row.title]
                         };
                     },
                 },
                 full: {
                     header: ['Name', 'Vendor'],
                     row: (row) => {
                         return {
                             onClick: () => onChangeViewFull(row),
                             items: [row.title, row.vendor]
                         };
                     },
                 },
                 results: {
                     header: ['Name', 'Vendor'],
                     row: (row) => {
                         return {
                             onClick: () => replaceCurrentPreviewPaneData(row),
                             items: [row.title, row.vendor]
                         };
                     },
                 },
             },

             // Package table options
             package: {
                 pane: {
                     header: ['Package', 'Vendor'],
                     row: (row) => {
                         return {
                             onClick: () => onChangeViewFull(row),
                             items: [row.title, row.vendor]
                         };
                     },
                 },
                 full: {
                     header: ['Package', 'Vendor'],
                     row: (row) => {
                         return {
                             onClick: () => onChangeViewFull(row),
                             items: [row.title, row.vendor]
                         };
                     },
                 },
                 results: {
                     header: ['Package', 'Vendor'],
                     row: (row) => {
                         return {
                             onClick: () => replaceCurrentPreviewPaneData(row),
                             items: [row.title, row.vendor]
                         };
                     },
                 },
             },

             // User table options
             user: {
                 pane: {
                     header: ['Name', 'Status'],
                     row: (row) => {
                         return {
                             onClick: () => onChangeViewFull(row),
                             items: [`${row.lastname}, ${row.firstname}`, row.status]
                         };
                     },
                 },
                 full: {
                     header: ['Name', 'Status'],
                     row: (row) => {
                         return {
                             onClick: () => onChangeViewFull(row),
                             items: [`${row.lastname}, ${row.firstname}`, row.status]
                         };
                     },
                 },
                 results: {
                     header: ['Name', 'Status'],
                     row: (row) => {
                         return {
                             onClick: () => replaceCurrentPreviewPaneData(row),
                             sortBy: row.lastname,
                             items: [`${row.lastname}, ${row.firstname}`, row.status]
                         };
                     },
                 },
             },

             // User table options
             loan: {
                 pane: {
                     header: ['Title', 'Item status'],
                     row: (row) => {
                         return {
                             onClick: () => onChangeView('loan-details-view', row),
                             items: [row.item_name, row.item_status]
                         };
                     },
                 },
                 full: {
                     header: ['Title', 'Item status'],
                     row: (row) => {
                         return {
                             onClick: () => onChangeViewFull(row),
                             items: [row.item_name, row.item_status]
                         };
                     },
                 },
                 results: {
                     header: ['Title', 'Item status', 'Due date', 'Request queue', 'Barcode', 'Call number', 'Renewal count', 'Loan policy', 'Location'],
                     row: (row) => {
                         return {
                             onClick: null,
                            //  onClick: () => onChangeView('loan-details-view', row),
                             items: [
                                 row.item_name,
                                 row.item_status,
                                 row.due_date,
                                 row.request_queue,
                                 row.barcode,
                                 row.call_number,
                                 row.renewal_count,
                                 row.loan_policy,
                                 row.location,
                             ]
                         };
                     },
                 },
             },

              // Loan actions
              loan_action: {
                  pane: {
                      header: ['Action date', 'Action', 'Due date', 'Item status', 'Desk', 'Source'],
                      row: (row) => {
                          return {
                              onClick: null,
                              items: [row.action_date, row.action, row.due_date, row.item_status, row.desk, row.source]
                          };
                      },
                  },
                  full: {
                     header: ['Action date', 'Action', 'Due date', 'Item status', 'Desk', 'Source'],
                      row: (row) => {
                          return {
                              onClick: null,
                              items: [row.action_date, row.action, row.due_date, row.item_status, row.desk, row.source]
                          };
                      },
                  },
                  results: {
                     header: ['Action date', 'Action', 'Due date', 'Item status', 'Desk', 'Source'],
                      row: (row) => {
                          return {
                              onClick: null,
                              items: [row.action_date, row.action, row.due_date, row.item_status, row.desk, row.source]
                          };
                      },
                  },
              },

              // Fee actions
              fee_action: {
                  results: {
                     header: ['Action date', 'Action', 'Balance', 'Trans. no.', 'Created at', 'Source', 'Notes'],
                      row: (row) => {
                          return {
                              onClick: null,
                              items: [row.action_date, row.action, row.balance, row.transaction_number, row.created_at, row.source, row.notes]
                          };
                      },
                  },
              },

              // Fees / fines
              fee: {
                  pane: {
                      header: ['Due date', 'Amount', 'Status'],
                      row: (row) => {
                          return {
                              onClick: () => {
                                  tools.changeView({
                                      ...tools.currentView,
                                      key: 'users-view',
                                      title: tools.currentView.data.pane.name,
                                  }, null, true);
                                  onChangeView('fee-details-view', row);
                              },
                              items: [row.due_date, row.amount, row.fee_status]
                          };
                      },
                  },
                  full: {
                      header: [],
                      row: (row) => {
                          return {
                              onClick: () => onChangeViewFull(row),
                              items: [row.item_name, row.item_status]
                          };
                      },
                  },
                  results: {
                      header: ['Date', 'Fee/fine type', 'Charged', 'Remaining', 'Title', 'Item Type', 'Barcode', 'Call number', 'Fee/fine owner'],
                      row: (row) => {
                          return {
                              onClick: null,
                             //  onClick: () => onChangeView('loan-details-view', row),
                              items: [
                                  row.due_date,
                                  row.fee_type,
                                  row.amount,
                                  row.remaining,
                                  {
                                      text: row.item_name,
                                      classes: 'max-width-175',
                                  },
                                  row.item_type,
                                  row.barcode,
                                  row.call_number,
                                  row.fee_owner,
                              ]
                          };
                      },
                  },
              },
         };
     };



// WEBPACK FOOTER //
// ./src/dummy/data-list.js